import React from "react";
import { Row, Col } from "reactstrap";
import Masonry from "react-masonry-css";
import mockData from "./mockData";
import cx from "classnames";
import TotCount from "../totCount";
import _ from "lodash";
import { act } from "react-dom/test-utils";
import guessed from "../../../../assets/images/tot/GUESSED.png";
import skipped from "../../../../assets/images/tot/SKIPPED.png";
const ListCard = (props) => {
  const { title, listData = [], classname } = props;
  return (
    <div className={`tot-list-card tot-head-card h-100 ${classname}`}>
      <div className="text">
        {title === "GUESSED" ? (
          <img src={guessed} alt="guessed" />
        ) : (
          <img src={skipped} alt="skipped" />
        )}
        <div>
          <TotCount
            color={title === "GUESSED" ? "green" : "yellow"}
            value={listData.length}
          />
        </div>
      </div>
     
      <Masonry
        breakpointCols={ 2}
        className="my-masonry-grid listWrapper"
        columnClassName="my-masonry-grid_column listWrapper_column"
      >
        {listData.map(({ word }) => (
        
          <p
            className={cx("g-name my-masonry-grid_column", {
              // singleColumn: listData.length <= 8,
              smallFont: word.length > 20,
              extraSmallFont: word.length > 36,
            })}
          >
            <span
              className={cx(
                "dot",
                `bg-gr-${title === "GUESSED" ? "green" : "yellow"}`
              )}
            />
            {word}
          </p>
         
        ))}
      </Masonry>
    
    </div>
  );
};

const GuessSkipList = ({
  screenParams,
  roomObj,
  activeGuesser,
  isGameOver,
}) => {
  const guessedLabel = _.get(screenParams, "tot.guessed_label") || "GUESSED";
  const skippedLabel = _.get(screenParams, "tot.skipped_label") || "SKIPPED";
  const guessedWords = _.get(roomObj, "game_state.right_words") || [];
  const skippedWords = _.get(roomObj, "game_state.skipped_words") || [];
  const activePlayerID =
    activeGuesser && activeGuesser.player_id ? activeGuesser.player_id : 0;
  let finalGuessWords = guessedWords.filter(
    (word) => word.player_id === activePlayerID
  );
  let finalSkippedWords = skippedWords.filter(
    (word) => word.player_id === activePlayerID
  );
  return (
    <div className="tot-50 tot-main">
      <Row className="h-100 pr-5 guessed-section">
        <Col lg={6} className="h-100">
          <ListCard
            title={guessedLabel}
            listData={isGameOver ? guessedWords : finalGuessWords}
            classname="gussed-list"
          />
        </Col>
        <Col lg={6} className="h-100">
          <ListCard
            title={skippedLabel}
            listData={isGameOver ? skippedWords : finalSkippedWords}
            classname="skipped-list"
          />
        </Col>
      </Row>
    </div>
  );
};

export default GuessSkipList;
